import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {abilitiesFeatureKey, AbilitiesState} from "./abilities.reducer";

export const getAbilitiesState = createFeatureSelector<AbilitiesState>(abilitiesFeatureKey);

export const getAbilities = createSelector(getAbilitiesState, (state) => state.data);
export const getAbilitiesLoading = createSelector(getAbilitiesState, SelectorUtil.isLoading);
